import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Flight Risk / Retention insights (Jun-21 AI handoff). Advisory only.
const FlightRiskService = {
  // Supervisor: only the logged-in supervisor's direct reports.
  getSupervisor: async (asOfDate) => {
    const res = await axiosInstance.get(API.attendance.supervisorFlightRisk(asOfDate));
    return res.data;
  },
  // Admin: company-wide, optional departmentId filter.
  getAdmin: async (asOfDate, departmentId) => {
    const res = await axiosInstance.get(API.attendance.adminFlightRisk(asOfDate, departmentId));
    return res.data;
  },
};

export default FlightRiskService;
